import React, { useContext, useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from "../../../../config/AuthContext";
import { GetUsuariIdJutgeActivitatsAlumnes } from "../../../../dao/GetUsuariIdJutgeActivitatsAlumnes";
import { GetUsuariIdJutgeActivitatsId } from "../../../../dao/GetUsuariIdJutgeActivitatsId";
import { GetRankingsUsuariId } from "../../../../dao/jutge/GetRankingsUsuariId";
import { GetActivitatsUsuarisRecompenses } from "../../../../dao/jutge/GetActivitatsUsuarisRecompenses";
import { Row, Col, Card, Typography, Statistic, Table, Tag, Progress, Tooltip, Avatar, Button, message, Modal, Badge, DatePicker, Select, Timeline, Empty, Space, Radio, Tabs, Popconfirm } from 'antd';
import RevisioModal from "./RevisioModal";
import { GetAlumneId } from "../../../../dao/GetAlumneId";
import { DefaultAulumneInfo } from "../../../../model/AlumneInfo";
import {
    TrophyOutlined, CheckCircleOutlined, CloseCircleOutlined, UserOutlined, AreaChartOutlined,
    LockOutlined, UnlockOutlined, ReloadOutlined, DesktopOutlined, GiftOutlined, CloseOutlined,
    ThunderboltOutlined, MinusCircleTwoTone, LeftOutlined, RightOutlined, FileOutlined,
    PlayCircleOutlined, BugOutlined, CodeOutlined, HistoryOutlined, PoweroffOutlined,
    UserSwitchOutlined, CopyOutlined, ClockCircleOutlined, StopOutlined, FolderOpenOutlined
} from '@ant-design/icons';

import dayjs, { Dayjs } from 'dayjs';
import Editor, { DiffEditor } from '@monaco-editor/react';
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import UseWebSocketSubscription from "../../../UseWebSocketSubscription";
import IdeFileBrowserModal from "../../ide/IdeFileBrowserModal";

const { Title, Text } = Typography;

interface ActivitatsIdEstadistiquesProps {
    idActivitatProp?: string;
    onClose?: () => void;
}

const ActivitatsIdEstadistiques = ({ idActivitatProp, onClose }: ActivitatsIdEstadistiquesProps = {}) => {
    const { isLoggedIn, userId, setLoggedIn, setUserId, setUser, setAlumneInfo, setUserPermisos } = useContext(AuthContext);
    const params = useParams();
    const id_activitat = idActivitatProp ?? params.id_activitat;
    const [dades, setDades] = useState<any[]>([]);
    const [avatars, setAvatars] = useState<Record<string, string>>({});
    const [subData, setSubData] = useState<Record<string, any[]>>({});
    const [rewardsData, setRewardsData] = useState<any[]>([]);
    const [selectedStudentRewards, setSelectedStudentRewards] = useState<any | null>(null);
    const [rewardsModalVisible, setRewardsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    // Estat de bloquejos d'IDE (examen) per alumne: { idUsuari: true/false }
    const [lockedUsers, setLockedUsers] = useState<Record<string, boolean>>({});
    const [unlocking, setUnlocking] = useState<string | null>(null);
    // Alumnes amb l'IDE obert (sessió activa): Set d'id_usuari
    const [openIdeUsers, setOpenIdeUsers] = useState<Set<string>>(new Set());
    const [startingIdeUser, setStartingIdeUser] = useState<string | null>(null);
    const [stoppingIdeUser, setStoppingIdeUser] = useState<string | null>(null);
    const [fileBrowserVisible, setFileBrowserVisible] = useState(false);
    const [fileBrowserUser, setFileBrowserUser] = useState<{ id: string; name: string } | null>(null);

    // Timeout / Inactivity Limit State
    const [timeoutMinutes, setTimeoutMinutes] = useState<number>(0);
    const [savingTimeout, setSavingTimeout] = useState<boolean>(false);

    // Modal d'edició del professor (RevisioModal)
    const [revisioVisible, setRevisioVisible] = useState(false);
    const [revisioElement, setRevisioElement] = useState<any>(null);

    // Estat d'arrencada massiva de dockers dels alumnes
    const [provisionModalVisible, setProvisionModalVisible] = useState(false);
    const [provisioningLoading, setProvisioningLoading] = useState(false);
    const [provisionProgress, setProvisionProgress] = useState<{ current: number; total: number } | null>(null);

    // ── Telemetria / Monitoreo cruzado ──────────────────────────────────────────
    const [telemetrySessions, setTelemetrySessions] = useState<Record<string, any>>({});
    const [telemetryModalVisible, setTelemetryModalVisible] = useState(false);
    const [telemetryStudent, setTelemetryStudent] = useState<any | null>(null);
    const [telemetryEvents, setTelemetryEvents] = useState<any[]>([]);
    const [telemetryClipboardEvents, setTelemetryClipboardEvents] = useState<any[]>([]);
    const [telemetryLockEvents, setTelemetryLockEvents] = useState<any[]>([]);
    const [activeTelemetryTabKey, setActiveTelemetryTabKey] = useState<'timeline' | 'clipboard' | 'locks'>('timeline');
    const [telemetryLoading, setTelemetryLoading] = useState(false);
    const [telemetryDate, setTelemetryDate] = useState<Dayjs>(dayjs());
    const [selectedFileFilter, setSelectedFileFilter] = useState<string | null>(null);
    // Modal visor de código diff/completo
    const [codeModalVisible, setCodeModalVisible] = useState(false);

    const [selectedCodeEvent, setSelectedCodeEvent] = useState<any | null>(null);
    const [previousCodeSnippet, setPreviousCodeSnippet] = useState<string | null>(null);
    const [codeViewMode, setCodeViewMode] = useState<'current' | 'diff'>('diff');

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_activitat, isLoggedIn]);

    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

    // Carrega sessions de telemetria per a conèixer l'estat en temps real (actiu/connectat/desconnectat)
    const fetchTelemetrySessions = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/telemetry/admin/sessions`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                if (Array.isArray(data)) {
                    const map: Record<string, any> = {};
                    data.forEach((s: any) => {
                        map[String(s.id_usuari)] = s;
                    });
                    setTelemetrySessions(map);
                }
            }
        } catch (e) { /* silenciós */ }
    };

    // Carrega l'estat de bloquejos (silenciós, no bloqueja la pantalla)
    const fetchLocks = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/locks`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setLockedUsers(data || {});
            }
        } catch (e) { /* silenciós */ }
    };

    // Carrega quins alumnes tenen l'IDE obert (sessió activa)
    const fetchOpenIdes = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/sessions`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setOpenIdeUsers(new Set(Object.keys(data || {}).map(String)));
            }
        } catch (e) { /* silenciós */ }
    };

    const fetchIdeTimeout = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/timeout`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                if (typeof data.timeoutMinutes === 'number') {
                    setTimeoutMinutes(data.timeoutMinutes);
                }
            }
        } catch (err) {
            console.error("Error fetching IDE timeout", err);
        }
    };

    const handleSaveTimeout = async (value: number) => {
        setSavingTimeout(true);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/timeout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ timeoutMinutes: value })
            });
            if (res.ok) {
                setTimeoutMinutes(value);
                if (value === 0) {
                    message.success("Duració de màquines restablerta al valor per defecte (1h normal / 4h examen)");
                } else {
                    message.success(`Duració de màquines fixada en ${value} minuts`);
                }
            } else {
                message.error("Error al desar la duració de les màquines");
            }
        } catch (err) {
            console.error("Error updating IDE timeout", err);
            message.error("Error de connexió");
        } finally {
            setSavingTimeout(false);
        }
    };

    // Refresc automàtic en segon pla cada 10s, SENSE spinner (no bloqueja la pantalla)
    useEffect(() => {
        if (!isLoggedIn) return;
        fetchLocks();
        fetchOpenIdes();
        fetchTelemetrySessions();
        fetchIdeTimeout();

        const interval = setInterval(() => {
            if (!document.hidden) {
                checkDades(true); // silent = true
                fetchLocks();
                fetchOpenIdes();
                fetchTelemetrySessions();
            }
        }, 10000);

        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, [isLoggedIn, id_activitat]);

    const hasOpenIde = (student: any) =>
        openIdeUsers.has(String(student.id_usuari)) || openIdeUsers.has(String(student.numericId));

    // Actualitzacions de bloqueig en temps real i sessions IDE
    UseWebSocketSubscription(
        isLoggedIn ? ['/topic/exam/locks', '/topic/ide/admin'] : [],
        (topic: string, data: any) => {
            if (topic === '/topic/ide/admin') {
                fetchOpenIdes();
            } else if (data && data.idUsuari !== undefined) {
                setLockedUsers(prev => ({ ...prev, [data.idUsuari]: data.locked }));
            }
        }
    );

    const isLocked = (student: any) =>
        !!(lockedUsers[String(student.id_usuari)] ?? lockedUsers[String(student.numericId)]);

    const handleStartStudentIde = async (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setStartingIdeUser(uid);
        const token = localStorage.getItem('authToken');
        try {
            message.loading({ content: `Iniciant màquina per ${student.usuari || student.nom || uid}...`, key: `ide-${uid}`, duration: 0 });
            const pracParam = id_activitat ? `&id_practica=${id_activitat}` : '';
            const res = await fetch(`${baseUrl}:8061/jutge/theia/port?id_usuari=${uid}&admin=true${pracParam}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success({ content: `Màquina iniciada per ${student.usuari || student.nom || uid}`, key: `ide-${uid}` });
                fetchOpenIdes();
            } else {
                message.error({ content: "Error en iniciar la màquina", key: `ide-${uid}` });
            }
        } catch (e) {
            message.error({ content: "Error de connexió", key: `ide-${uid}` });
        } finally {
            setStartingIdeUser(null);
        }
    };

    const handleStopStudentIde = async (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setStoppingIdeUser(uid);
        const token = localStorage.getItem('authToken');
        try {
            message.loading({ content: `Aturant màquina de ${student.usuari || student.nom || uid}...`, key: `stop-${uid}`, duration: 0 });
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/sessions/${uid}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success({ content: `Màquina de ${student.usuari || student.nom || uid} aturada`, key: `stop-${uid}` });
                fetchOpenIdes();
            } else {
                message.error({ content: "Error en aturar la màquina", key: `stop-${uid}` });
            }
        } catch (e) {
            message.error({ content: "Error de connexió", key: `stop-${uid}` });
        } finally {
            setStoppingIdeUser(null);
        }
    };

    const openStudentFileBrowser = (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setFileBrowserUser({
            id: uid,
            name: student.usuari || student.nom || uid
        });
        setFileBrowserVisible(true);
    };

    const unlockStudent = async (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setUnlocking(uid);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/unlock`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ id_usuari: uid })
            });
            if (res.ok) {
                message.success(`IDE desbloquejat per a ${student.usuari || uid}`);
                setLockedUsers(prev => ({ ...prev, [String(student.id_usuari)]: false, [uid]: false }));
            } else {
                message.error("Error al desbloquejar l'IDE");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setUnlocking(null);
        }
    };

    // Arrenca els contenidors Docker de tots els alumnes de l'activitat/aula
    const handleProvisionAllDockers = async () => {
        if (!dades || dades.length === 0) {
            message.warning("No hi ha alumnes en aquesta activitat");
            return;
        }

        setProvisioningLoading(true);
        setProvisionProgress({ current: 0, total: dades.length });

        try {
            const token = localStorage.getItem('authToken');
            let successCount = 0;

            for (let i = 0; i < dades.length; i++) {
                const student = dades[i];
                const studentId = student.id_usuari || student.numericId;
                setProvisionProgress({ current: i + 1, total: dades.length });

                try {
                    const pracParam = id_activitat ? `&id_practica=${id_activitat}` : '';
                    const response = await fetch(`${baseUrl}:8061/jutge/theia/port?id_usuari=${studentId}&admin=true${pracParam}`, {
                        method: 'GET',
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (response.ok) {
                        successCount++;
                    }
                } catch (err) {
                    console.error(`Error en arrencar docker per l'alumne ${studentId}`, err);
                }
            }

            if (successCount === dades.length) {
                message.success(`S'han iniciat correctament els contenidors de tots els alumnes (${successCount})`);
            } else if (successCount > 0) {
                message.warning(`S'han iniciat ${successCount} de ${dades.length} contenidors`);
            } else {
                message.error("Error en iniciar els contenidors Docker");
            }

            setProvisionModalVisible(false);
            setTimeout(() => {
                fetchOpenIdes();
                fetchTelemetrySessions();
            }, 2000);
        } catch (error) {
            console.error("Error en provisió massiva de contenidors", error);
            message.error("Error de connexió en arrencar contenidors");
        } finally {
            setProvisioningLoading(false);
            setProvisionProgress(null);
        }
    };

    const handleImpersonate = async (targetId: string) => {
        try {
            message.loading("Impersonant usuari...");

            const response = await fetch(`${baseUrl}:8061/login/impersonate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify({ adminId: userId, targetId })
            });

            if (response.ok) {
                const data = await response.json();
                const { token, permisos } = data;

                let alu = DefaultAulumneInfo;
                if (permisos && permisos.length > 0) {
                    const res = await GetAlumneId(permisos[0].id, token);
                    if (res) alu = res;
                }

                if (!localStorage.getItem('adminToken')) {
                    localStorage.setItem('adminToken', localStorage.getItem('authToken') || '');
                    localStorage.setItem('admin_userId', localStorage.getItem('userId') || '');
                    localStorage.setItem('admin_user', localStorage.getItem('user') || '');
                    localStorage.setItem('admin_userPermisos', localStorage.getItem('userPermisos') || '');
                    localStorage.setItem('admin_alumneInfo', localStorage.getItem('alumneInfo') || '');
                }

                localStorage.setItem('authToken', token);

                setLoggedIn(true);
                setUserId(String(permisos[0].id));
                setUser(permisos[0]);
                setUserPermisos(permisos);
                setAlumneInfo(alu);

                message.success('Impersonant...');
                window.location.reload();

            } else {
                message.error('Error al impersonar');
            }
        } catch (e) {
            console.error(e);
            message.error('Error de connexió');
        }
    };

    const [loadingExercises, setLoadingExercises] = useState(false);

    async function checkDades(silent: boolean = false) {
        if (!silent) setLoading(true);
        try {
            // 1. Carga inmediata de la lista de alumnos, rankings y recompensas en paralelo
            const [dad, rankData, rew] = await Promise.all([
                GetUsuariIdJutgeActivitatsAlumnes(id_activitat + ""),
                GetRankingsUsuariId(userId + ""),
                GetActivitatsUsuarisRecompenses(id_activitat + "")
            ]);

            const students = dad || [];
            // Conservamos los valores ya calculados (be, malament, progres, intents) para no parpadear a 0
            setDades(prev => {
                const prevMap = new Map((prev || []).map((s: any) => [String(s.id_usuari ?? s.numericId ?? s.id), s]));
                return students.map((s: any) => {
                    const stId = String(s.id_usuari ?? s.numericId ?? s.id);
                    const old = prevMap.get(stId);
                    if (!old) return s;
                    return {
                        ...s,
                        intents: old.intents ?? s.intents ?? 0,
                        be: old.be ?? s.be ?? 0,
                        malament: old.malament ?? s.malament ?? 0,
                        progres: old.progres ?? s.progres ?? 0
                    };
                });
            });

            if (rankData) {
                const ranking = Array.isArray(rankData) ? rankData : rankData.ranking || [];
                const map: Record<string, string> = {};
                ranking.forEach((r: any) => {
                    const uid = r.id_usuari || r.id;
                    if (uid && r.avatar) map[String(uid)] = r.avatar;
                });
                setAvatars(map);
            }

            setRewardsData(rew || []);

            // Desactivamos el spinner principal de inmediato para mostrar las cards y la tabla
            if (!silent) setLoading(false);

            // 2. Carga progresiva en segundo plano de los ejercicios por alumno (lotes concurrentes de 4)
            if (students.length > 0) {
                loadExercisesProgressively(students);
            }
        } catch (error) {
            console.error("Error cargando estadísticas", error);
            if (!silent) setLoading(false);
        }
    }

    async function loadExercisesProgressively(students: any[]) {
        setLoadingExercises(true);
        const batchSize = 4;

        for (let i = 0; i < students.length; i += batchSize) {
            const batch = students.slice(i, i + batchSize);
            const batchResults = await Promise.all(
                batch.map(async (student: any) => {
                    try {
                        const ex = await GetUsuariIdJutgeActivitatsId(student.id_usuari + "", id_activitat + "");
                        return { id_usuari: student.id_usuari, exercicis: ex || [] };
                    } catch {
                        return { id_usuari: student.id_usuari, exercicis: [] };
                    }
                })
            );

            // Actualizamos progresivamente subData
            setSubData(prev => {
                const updated = { ...prev };
                batchResults.forEach(r => {
                    updated[r.id_usuari] = r.exercicis;
                });
                return updated;
            });

            // Actualizamos los datos de cada alumno en dades (progreso, be, malament)
            setDades(prevList => {
                return (prevList || []).map(st => {
                    const stId = String(st.id_usuari ?? st.numericId ?? st.id);
                    const found = batchResults.find(b => String(b.id_usuari) === stId);
                    if (!found || !found.exercicis || found.exercicis.length === 0) return st;

                    const totalExercicis = found.exercicis.length;
                    const totalTests = found.exercicis.reduce((acc: number, ex: any) => acc + (Number(ex.tests) || 0), 0);
                    const totalBe = found.exercicis.reduce((acc: number, ex: any) => acc + (Number(ex.progres2) || (Number(ex.progres) === 1 ? (Number(ex.tests) || 1) : 0)), 0);
                    const totalIntents = found.exercicis.reduce((acc: number, ex: any) => acc + (Number(ex.intents) || 0), 0);

                    // Progrés de l'alumne:
                    // 1. Si tenen tests definits, % de tests superats (totalBe / totalTests)
                    // 2. Si no hi ha tests definits, mitjana directa del 'progres' de cada exercici (ex.progres: 0 a 1) o exercicis superats
                    let progres = 0;
                    if (totalTests > 0) {
                        progres = (totalBe / totalTests) * 100;
                    } else if (totalExercicis > 0) {
                        const sumProgres = found.exercicis.reduce((acc: number, ex: any) => {
                            if (Number(ex.progres) > 0) return acc + Number(ex.progres);
                            if (ex.origen_success !== undefined && ex.origen_success !== null) return acc + 1;
                            return acc;
                        }, 0);
                        progres = (sumProgres / totalExercicis) * 100;
                    }

                    return {
                        ...st,
                        intents: totalIntents,
                        be: totalBe,
                        malament: Math.max(0, (totalIntents - totalBe)),
                        progres: Number(Math.min(100, Math.max(0, progres)).toFixed(1))
                    };
                });
            });
        }
        setLoadingExercises(false);
    }

    function getAvatarSrc(img: string | undefined | null) {
        if (!img || img === "undefined" || img === "null") return undefined;
        if (img.startsWith("http") || img.startsWith("data:") || img.startsWith("/")) return img;
        if (img.startsWith("base64:")) img = img.split(":").pop()!;
        if (img.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
        if (img.startsWith("iVB")) return `data:image/png;base64,${img}`;
        return `data:image/png;base64,${img}`;
    }

    // Formatear duración de segundos a texto legible
    function formatDuration(totalSeconds: number): string {
        const s = Math.max(0, Math.floor(totalSeconds || 0));
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        if (h > 0) return `${h}h ${m}m`;
        if (m > 0) return `${m}m ${s % 60}s`;
        return `${s}s`;
    }

    function formatDateTime(iso?: string): string {
        if (!iso) return '—';
        const dj = dayjs(iso);
        if (!dj.isValid()) return iso;
        return dj.toDate().toLocaleString();
    }

    // Calcula el estado en tiempo real para un alumno: activo (escribiendo código), conectado (con IDE abierto), desconectado
    const getStudentTelemetryStatus = (student: any): { status: 'activo' | 'conectado' | 'desconectado'; session?: any } => {
        const uid = String(student.id_usuari || student.numericId);
        const session = telemetrySessions[uid];
        if (!session) {
            if (hasOpenIde(student)) return { status: 'conectado' };
            return { status: 'desconectado' };
        }
        if (!session.online) {
            if (hasOpenIde(student)) return { status: 'conectado', session };
            return { status: 'desconectado', session };
        }
        if (session.last_edits > 0) {
            return { status: 'activo', session };
        }
        return { status: 'conectado', session };
    };

    // Abre modal de historial de telemetría para un alumno
    const openTelemetryDetail = async (student: any) => {
        setTelemetryStudent(student);
        setTelemetryModalVisible(true);
        setSelectedFileFilter(null);
        setActiveTelemetryTabKey('timeline');
        setTelemetryDate(dayjs());
        setTelemetryEvents([]);
        setTelemetryClipboardEvents([]);
        setTelemetryLockEvents([]);
        setTelemetryLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const uid = student.id_usuari || student.numericId;
            const [res, clipRes, lockRes] = await Promise.all([
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}/clipboard`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}/lock-events`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
            ]);
            if (res.ok) {
                const data = await res.json();
                setTelemetryEvents(Array.isArray(data) ? data : []);
            } else {
                message.error("No s'ha pogut carregar l'historial de telemetria");
            }
            if (clipRes.ok) {
                const clipData = await clipRes.json();
                setTelemetryClipboardEvents(Array.isArray(clipData) ? clipData : []);
            }
            if (lockRes.ok) {
                const lockData = await lockRes.json();
                setTelemetryLockEvents(Array.isArray(lockData) ? lockData : []);
            }
        } catch (e) {
            message.error("Error de xarxa en carregar l'historial");
        } finally {
            setTelemetryLoading(false);
        }
    };


    const isTodaySelected = telemetryDate.isSame(dayjs(), 'day');

    // Filtrar eventos por fecha seleccionada
    const displayedTelemetryEvents = useMemo(() => {
        return telemetryEvents.filter(ev => {
            if (!ev.event_ts) return false;
            const d = dayjs(ev.event_ts);
            return d.isValid() && d.isSame(telemetryDate, 'day');
        });
    }, [telemetryEvents, telemetryDate]);

    // Archivos detectados en la fecha seleccionada
    const availableTelemetryFiles = useMemo(() => {
        const fileMap: Record<string, { count: number; edits: number; language?: string }> = {};
        displayedTelemetryEvents.forEach(ev => {
            const f = ev.file || '(Sense fitxer)';
            if (!fileMap[f]) fileMap[f] = { count: 0, edits: 0, language: ev.language };
            fileMap[f].count += 1;
            fileMap[f].edits += (ev.edits || 0);
            if (!fileMap[f].language && ev.language) fileMap[f].language = ev.language;
        });
        return fileMap;
    }, [displayedTelemetryEvents]);

    // Eventos tras filtrar por fichero si aplica
    const eventsFilteredByFile = useMemo(() => {
        if (!selectedFileFilter) return displayedTelemetryEvents;
        return displayedTelemetryEvents.filter(ev => (ev.file || '(Sense fitxer)') === selectedFileFilter);
    }, [displayedTelemetryEvents, selectedFileFilter]);

    // Agrupación de timeline idéntica a IdeTelemetryDashboard
    const groupedTelemetryItems = useMemo(() => {
        const getEvStatus = (ev: any): 'activo' | 'conectado' | 'desconectado' => {
            const isOnline = Number(ev.active) === 1 || Number(ev.focused) === 1;
            if (!isOnline) return 'desconectado';
            if ((ev.edits || 0) > 0 || (ev.runs || 0) > 0 || (ev.debugs || 0) > 0) return 'activo';
            return 'conectado';
        };

        const result: any[] = [];
        let i = 0;
        const events = eventsFilteredByFile;

        while (i < events.length) {
            const ev = events[i];
            const evStatus = getEvStatus(ev);
            const hasEditsOrExec = (ev.edits > 0) || ((ev.runs || 0) > 0) || ((ev.debugs || 0) > 0);

            let prevSnippet: string | null = null;
            let hasCodeChange = false;

            if (ev.code_snippet) {
                for (let k = i + 1; k < events.length; k++) {
                    if (events[k].code_snippet && (!ev.file || events[k].file === ev.file)) {
                        prevSnippet = events[k].code_snippet || null;
                        break;
                    }
                }
                if (ev.edits > 0 || (prevSnippet !== null && prevSnippet !== ev.code_snippet)) {
                    hasCodeChange = true;
                }
            }

            if (hasEditsOrExec || hasCodeChange) {
                result.push({
                    isGroup: false,
                    representativeEvent: ev,
                    count: 1,
                    startTs: ev.event_ts,
                    endTs: ev.event_ts,
                    totalActiveSeconds: ev.active_seconds || 0,
                    eventStatus: evStatus,
                    file: ev.file,
                    files: ev.file ? [ev.file] : [],
                    language: ev.language,
                    project: ev.project,
                    hasCodeChange,
                    prevSnippet
                });
                i++;
                continue;
            }

            const fileSet = new Set<string>();
            if (ev.file) fileSet.add(ev.file);
            let groupCount = 1;
            let totalActiveSecs = ev.active_seconds || 0;
            let lastEventTs = ev.event_ts;
            let j = i + 1;

            while (j < events.length) {
                const nextEv = events[j];
                const nextHasEdits = (nextEv.edits > 0) || ((nextEv.runs || 0) > 0) || ((nextEv.debugs || 0) > 0);
                const nextStatus = getEvStatus(nextEv);

                if (nextHasEdits || nextStatus !== evStatus) break;
                if (nextEv.file) fileSet.add(nextEv.file);
                groupCount++;
                totalActiveSecs += (nextEv.active_seconds || 0);
                lastEventTs = nextEv.event_ts;
                j++;
            }

            result.push({
                isGroup: groupCount > 1,
                representativeEvent: ev,
                count: groupCount,
                startTs: lastEventTs,
                endTs: ev.event_ts,
                totalActiveSeconds: totalActiveSecs,
                eventStatus: evStatus,
                file: ev.file,
                files: Array.from(fileSet),
                language: ev.language,
                project: ev.project,
                hasCodeChange: false,
                prevSnippet: null
            });

            i = j;
        }

        return result;
    }, [eventsFilteredByFile]);

    const stats = useMemo(() => {
        if (!dades || dades.length === 0) return { avgProgress: 0, totalBe: 0, totalMalament: 0, topStudents: [], passedCount: 0 };

        let avgProgress = 0;
        let totalBe = 0;
        let totalMalament = 0;
        let passedCount = 0;

        dades.forEach(student => {
            const progress = Number(student.progres) || 0;
            avgProgress += progress;
            totalBe += (student.be || 0);
            totalMalament += (student.malament || 0);
            if (progress >= 50) passedCount++;
        });

        avgProgress = avgProgress / dades.length;

        const topStudents = [...dades].sort((a, b) => Number(b.progres) - Number(a.progres)).slice(0, 5);

        return { avgProgress, totalBe, totalMalament, topStudents, passedCount };
    }, [dades]);

    const renderProgressChart = () => {
        const ranges = [
            { label: 'Excelente (90-100%)', count: dades.filter(s => Number(s.progres) >= 90).length, color: '#52c41a' },
            { label: 'Notable (70-89%)', count: dades.filter(s => Number(s.progres) >= 70 && Number(s.progres) < 90).length, color: '#1890ff' },
            { label: 'Bien/Aprob. (50-69%)', count: dades.filter(s => Number(s.progres) >= 50 && Number(s.progres) < 70).length, color: '#faad14' },
            { label: 'Suspenso (0-49%)', count: dades.filter(s => Number(s.progres) < 50).length, color: '#f5222d' },
        ];

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {ranges.map((range, index) => (
                    <div key={index}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                            <Text>{range.label}</Text>
                            <Text strong>{range.count} alu.</Text>
                        </div>
                        <Progress percent={dades.length > 0 ? (range.count / dades.length) * 100 : 0} strokeColor={range.color} showInfo={false} />
                    </div>
                ))}
            </div>
        );
    };

    const columnsTop = [
        {
            title: 'Pos',
            key: 'pos',
            width: 60,
            render: (_: any, __: any, index: number) => {
                const colors = ['#fadb14', '#d9d9d9', '#ad8b00'];
                return index < 3 ? <TrophyOutlined style={{ color: colors[index], fontSize: '18px' }} /> : <Text>{index + 1}</Text>;
            }
        },
        {
            title: 'Alumne',
            dataIndex: 'usuari',
            key: 'usuari',
            render: (text: string) => <Text strong>{text}</Text>
        },
        {
            title: 'Correctes',
            dataIndex: 'be',
            key: 'be',
            align: 'center' as const,
            render: (val: number) => <Tag color="success">{val}</Tag>
        },
        {
            title: 'Progrés',
            dataIndex: 'progres',
            key: 'progres',
            align: 'right' as const,
            render: (val: number) => <Tag color="blue" style={{ fontWeight: 'bold' }}>{val.toFixed(2)}%</Tag>
        }
    ];

    return (
        <div style={{ padding: '24px', background: '#f0f2f5', minHeight: '100vh' }}>
            <div style={{ marginBottom: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                    <Title level={2} style={{ marginBottom: 0 }}><AreaChartOutlined /> Estadístiques de l'Activitat</Title>
                    <Text type="secondary">
                        {loadingExercises ? "Actualitzant mètriques i exercicis en segon pla..." : "Resum global del progrés i rendiment dels alumnes."}
                    </Text>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Button
                        type="primary"
                        style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                        icon={<PoweroffOutlined />}
                        onClick={() => setProvisionModalVisible(true)}
                        loading={provisioningLoading}
                        disabled={!dades || dades.length === 0}
                    >
                        Arrencar Dockers Alumnes
                    </Button>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#fff', padding: '2px 10px', borderRadius: '6px', border: '1px solid #d9d9d9' }}>
                        <ClockCircleOutlined style={{ color: '#1890ff', fontSize: 13 }} />
                        <span style={{ fontSize: '12px', fontWeight: 500 }}>Duració:</span>
                        <Select
                            size="small"
                            style={{ width: 145 }}
                            value={timeoutMinutes}
                            loading={savingTimeout}
                            onChange={(val) => handleSaveTimeout(val)}
                        >
                            <Select.Option value={0}>Per defecte (1h / 4h)</Select.Option>
                            <Select.Option value={15}>15 minuts</Select.Option>
                            <Select.Option value={30}>30 minuts</Select.Option>
                            <Select.Option value={45}>45 minuts</Select.Option>
                            <Select.Option value={60}>1 hora</Select.Option>
                            <Select.Option value={90}>1h 30m</Select.Option>
                            <Select.Option value={120}>2 hores</Select.Option>
                            <Select.Option value={180}>3 hores</Select.Option>
                            <Select.Option value={240}>4 hores</Select.Option>
                            <Select.Option value={360}>6 hores</Select.Option>
                            <Select.Option value={480}>8 hores</Select.Option>
                            <Select.Option value={1440}>24 hores (1 dia)</Select.Option>
                        </Select>
                    </div>
                    <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        onClick={async () => { await checkDades(); fetchLocks(); fetchOpenIdes(); }}
                        loading={loading || loadingExercises}
                    >
                        Refrescar
                    </Button>
                    {onClose && (
                        <Button
                            danger
                            icon={<CloseOutlined />}
                            onClick={onClose}
                        >
                            Tancar Estadístiques
                        </Button>
                    )}
                </div>
            </div>

            <Row gutter={[24, 24]}>
                {/* Global Metrics */}
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <Statistic title="Alumnes Totals" value={dades.length} prefix={<UserOutlined />} />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <Statistic
                            title="Progrés Mitjà"
                            value={stats.avgProgress}
                            precision={2}
                            suffix="%"
                            valueStyle={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#f5222d' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <Statistic
                            title="Aprovats (≥50%)"
                            value={stats.passedCount}
                            suffix={`/ ${dades.length}`}
                            valueStyle={{ color: '#1890ff' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <Statistic
                            title="Tests"
                            value={stats.totalBe}
                            suffix={<span style={{ fontSize: 14, color: '#ff4d4f' }}> / {stats.totalMalament} <CloseCircleOutlined /></span>}
                            prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                        />
                        <Text type="secondary" style={{ fontSize: 12 }}>Correctes / Incorrectes</Text>
                    </Card>
                </Col>

                {/* IDEs bloquejats */}
                {(() => {
                    const lockedCount = dades.filter(s => isLocked(s)).length;
                    return (
                        <Col xs={24}>
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: 12,
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                    background: lockedCount > 0 ? '#fff1f0' : '#f6ffed',
                                    border: `1px solid ${lockedCount > 0 ? '#ffccc7' : '#d9f7be'}`
                                }}
                                bodyStyle={{ padding: '12px 16px' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                    {lockedCount > 0
                                        ? <LockOutlined style={{ color: '#cf1322', fontSize: 20 }} />
                                        : <UnlockOutlined style={{ color: '#389e0d', fontSize: 20 }} />}
                                    <Text strong style={{ color: lockedCount > 0 ? '#cf1322' : '#389e0d' }}>
                                        {lockedCount > 0
                                            ? `${lockedCount} alumne(s) amb l'IDE d'examen bloquejat`
                                            : "Cap IDE d'examen bloquejat"}
                                    </Text>
                                    {lockedCount > 0 && (
                                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                            {dades.filter(s => isLocked(s)).map(s => (
                                                <Button
                                                    key={s.id_usuari}
                                                    size="small"
                                                    danger
                                                    icon={<UnlockOutlined />}
                                                    loading={unlocking === String(s.numericId || s.id_usuari)}
                                                    onClick={() => unlockStudent(s)}
                                                >
                                                    {s.usuari}
                                                </Button>
                                            ))}
                                        </div>
                                    )}
                                    <Text type="secondary" style={{ fontSize: 12, marginLeft: 'auto' }}>
                                        Actualització automàtica cada 10s
                                    </Text>
                                </div>
                            </Card>
                        </Col>
                    );
                })()}

                {/* Resum de Telemetria en Temps Real (Monitoreo IDE) */}
                {(() => {
                    const activeStudents = dades.filter(s => getStudentTelemetryStatus(s).status === 'activo');
                    const connectedStudents = dades.filter(s => getStudentTelemetryStatus(s).status === 'conectado');
                    return (
                        <Col xs={24}>
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: 12,
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                    background: '#ffffff',
                                    border: '1px solid #e8e8e8'
                                }}
                                bodyStyle={{ padding: '12px 16px' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                                        <Space size="middle">
                                            <Tag color="green" icon={<ThunderboltOutlined />} style={{ fontSize: 13, padding: '4px 10px', borderRadius: 8 }}>
                                                <strong>{activeStudents.length}</strong> Actius (escribint codi)
                                            </Tag>
                                            <Tag color="blue" icon={<DesktopOutlined />} style={{ fontSize: 13, padding: '4px 10px', borderRadius: 8 }}>
                                                <strong>{connectedStudents.length}</strong> Connectats (IDE obert)
                                            </Tag>
                                            <Tag color="default" style={{ fontSize: 13, padding: '4px 10px', borderRadius: 8 }}>
                                                <strong>{dades.length - (activeStudents.length + connectedStudents.length)}</strong> Desconnectats
                                            </Tag>
                                        </Space>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            Monitoreig en temps real creuat amb l'IDE
                                        </Text>
                                        <Button
                                            size="small"
                                            icon={<ReloadOutlined />}
                                            onClick={() => fetchTelemetrySessions()}
                                        >
                                            Refrescar IDE
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    );
                })()}

                {/* Student Avatar Cards */}
                <Col xs={24}>
                    <div style={{ marginTop: 24, marginBottom: 16 }}>
                        <Title level={4}>Detall per Alumne</Title>
                    </div>
                    <Row gutter={[16, 16]}>
                        {dades.map(student => {
                            const stringToColor = (str: string) => {
                                let hash = 0;
                                for (let i = 0; i < str.length; i++) {
                                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                                }
                                const c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
                                return '#' + '00000'.substring(0, 6 - c.length) + c;
                            };

                            const name = student.usuari || 'Anònim';
                            const initials = name.substring(0, 2).toUpperCase();
                            const avatarColor = stringToColor(name);
                            const studentExercises = subData[student.id_usuari] || [];

                            let displayName = name;
                            const parts = name.trim().split(/\s+/);
                            if (parts.length > 1 && name.length > 12) {
                                displayName = `${parts[0]} ${parts[1].substring(0, 1).toUpperCase()}.`;
                            }

                            const tel = getStudentTelemetryStatus(student);
                            const telStatus = tel.status;
                            const telSession = tel.session;

                            // Borde de la tarjeta:
                            // 1. Bloquejat (rojo)
                            // 2. Telemetria ACTIVO (verde fosforescente/resplandeciente - escribiendo código)
                            // 3. Telemetria CONECTADO / IDE abierto (lila/azul - IDE abierto)
                            // 4. Normal
                            const cardBorderShadow = isLocked(student)
                                ? '0 0 0 2px #ff4d4f'
                                : (telStatus === 'activo'
                                    ? '0 0 0 2.5px #52c41a, 0 2px 10px rgba(82, 196, 26, 0.25)'
                                    : (telStatus === 'conectado' || hasOpenIde(student)
                                        ? '0 0 0 2px #1890ff'
                                        : '0 2px 8px rgba(0,0,0,0.04)'));

                            return (
                                <Col xs={24} sm={12} md={8} lg={6} xl={4} key={student.id_usuari}>
                                    <Card
                                        hoverable
                                        bordered={false}
                                        style={{
                                            borderRadius: 12,
                                            boxShadow: cardBorderShadow,
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                            cursor: 'default'
                                        }}
                                        bodyStyle={{ padding: 12 }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                                            {avatars[student.id_usuari] ? (
                                                <div style={{
                                                    width: 42,
                                                    height: 42,
                                                    borderRadius: '50%',
                                                    overflow: 'hidden',
                                                    border: '1px solid #f0f0f0',
                                                    flexShrink: 0
                                                }}>
                                                    <img
                                                        src={getAvatarSrc(avatars[student.id_usuari])}
                                                        alt="avatar"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                                    />
                                                </div>
                                            ) : (
                                                <Avatar
                                                    size={42}
                                                    style={{
                                                        backgroundColor: avatarColor,
                                                        verticalAlign: 'middle',
                                                        border: '1px solid #f0f0f0',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    {initials}
                                                </Avatar>
                                            )}

                                            <div style={{ marginLeft: 10, flexGrow: 1, minWidth: 0 }}>
                                                <Text
                                                    strong
                                                    style={{
                                                        display: 'block',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        fontSize: 14,
                                                        lineHeight: 1.2,
                                                        marginBottom: 4
                                                    }}
                                                    title={name}
                                                >
                                                    {displayName}
                                                </Text>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                                    <Tag color={Number(student.progres) >= 50 ? "green" : "red"} style={{ margin: 0, fontSize: 10, borderRadius: 8, padding: '0 4px' }}>
                                                        {Number(student.progres || 0).toFixed(1)}%
                                                    </Tag>

                                                    {/* Botón Ver Recompensas */}
                                                    <Tooltip title="Veure recompenses obtingudes">
                                                        <Button
                                                            size="small"
                                                            type="text"
                                                            icon={<GiftOutlined style={{ color: '#faad14', fontSize: '13px' }} />}
                                                            style={{ padding: '0 4px', height: '20px', minWidth: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedStudentRewards({
                                                                    student,
                                                                    rewards: rewardsData.filter((r: any) => String(r.id_usuari) === String(student.id_usuari))
                                                                });
                                                                setRewardsModalVisible(true);
                                                            }}
                                                        />
                                                    </Tooltip>

                                                    {/* Botón Historial de Telemetría */}
                                                    <Tooltip title="Veure historial de telemetria i activitat IDE">
                                                        <Button
                                                            size="small"
                                                            type="text"
                                                            icon={<HistoryOutlined style={{ color: '#1890ff', fontSize: '13px' }} />}
                                                            style={{ padding: '0 4px', height: '20px', minWidth: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openTelemetryDetail(student);
                                                            }}
                                                        />
                                                    </Tooltip>

                                                    {/* Botón Impersonar Alumno */}
                                                    <Tooltip title="Impersonar Alumne">
                                                        <Button
                                                            size="small"
                                                            type="text"
                                                            icon={<UserSwitchOutlined style={{ color: '#1890ff', fontSize: '13px' }} />}
                                                            style={{ padding: '0 4px', height: '20px', minWidth: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleImpersonate(String(student.id_usuari || student.numericId || student.id));
                                                            }}
                                                        />
                                                    </Tooltip>

                                                    {/* Botons Gestió IDE Alumne: Arrencar / Aturar / Explorar */}
                                                    {!hasOpenIde(student) ? (
                                                        <Tooltip title="Arrencar màquina (Theia IDE)">
                                                            <Button
                                                                size="small"
                                                                type="text"
                                                                loading={startingIdeUser === String(student.numericId || student.id_usuari)}
                                                                icon={<PlayCircleOutlined style={{ color: '#52c41a', fontSize: '14px' }} />}
                                                                style={{ padding: '0 4px', height: '20px', minWidth: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleStartStudentIde(student);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    ) : (
                                                        <>
                                                            <Tooltip title="Explorar carpetes i fitxers de l'alumne">
                                                                <Button
                                                                    size="small"
                                                                    type="text"
                                                                    icon={<FolderOpenOutlined style={{ color: '#fa8c16', fontSize: '14px' }} />}
                                                                    style={{ padding: '0 4px', height: '20px', minWidth: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        openStudentFileBrowser(student);
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                            <Popconfirm
                                                                title="Aturar màquina?"
                                                                description="Això apagarà el contenidor Theia de l'alumne."
                                                                onConfirm={(e) => {
                                                                    e?.stopPropagation();
                                                                    handleStopStudentIde(student);
                                                                }}
                                                                onCancel={(e) => e?.stopPropagation()}
                                                                okText="Sí, aturar"
                                                                cancelText="Cancel·lar"
                                                                okType="danger"
                                                            >
                                                                <Tooltip title="Aturar màquina (Theia IDE)">
                                                                    <Button
                                                                        size="small"
                                                                        type="text"
                                                                        danger
                                                                        loading={stoppingIdeUser === String(student.numericId || student.id_usuari)}
                                                                        icon={<StopOutlined style={{ color: '#ff4d4f', fontSize: '14px' }} />}
                                                                        style={{ padding: '0 4px', height: '20px', minWidth: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    />
                                                                </Tooltip>
                                                            </Popconfirm>
                                                        </>
                                                    )}

                                                    {/* Estado de Telemetría / IDE en tiempo real */}
                                                    {!isLocked(student) && telStatus === 'activo' && (
                                                        <Tooltip title={`Escribint codi ara mateix${telSession?.last_file ? ` a ${telSession.last_file}` : ''}. Clica per veure historial.`}>
                                                            <Tag
                                                                color="green"
                                                                icon={<ThunderboltOutlined />}
                                                                style={{ margin: 0, fontSize: 10, borderRadius: 8, padding: '0 4px', cursor: 'pointer', fontWeight: 'bold' }}
                                                                onClick={() => openTelemetryDetail(student)}
                                                            >
                                                                ACTIU
                                                            </Tag>
                                                        </Tooltip>
                                                    )}

                                                    {!isLocked(student) && telStatus === 'conectado' && (
                                                        <Tooltip title="IDE obert (connectat). Clica per veure historial.">
                                                            <Tag
                                                                color="blue"
                                                                icon={<DesktopOutlined />}
                                                                style={{ margin: 0, fontSize: 10, borderRadius: 8, padding: '0 4px', cursor: 'pointer' }}
                                                                onClick={() => openTelemetryDetail(student)}
                                                            >
                                                                IDE
                                                            </Tag>
                                                        </Tooltip>
                                                    )}

                                                    {isLocked(student) && (
                                                        <Tooltip title="IDE d'examen bloquejat. Clica per desbloquejar.">
                                                            <Tag
                                                                color="red"
                                                                icon={<LockOutlined />}
                                                                onClick={() => unlockStudent(student)}
                                                                style={{ margin: 0, fontSize: 10, borderRadius: 8, padding: '0 4px', cursor: 'pointer' }}
                                                            >
                                                                Bloquejat
                                                            </Tag>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Colored exercise squares */}
                                        <div style={{ display: 'flex', gap: 2, flexWrap: 'wrap', marginTop: 10 }}>
                                            {studentExercises.length > 0 ? studentExercises.map((ex: any, idx: number) => {
                                                const color = ex.progres === 1 ? '#52c41a' :
                                                    ex.progres > 0 ? '#faad14' :
                                                        (ex.intents > 0 ? '#f5222d' : '#f0f0f0');

                                                // Trofeo solo si la solución se hizo en Desafío (1) o Juego (2)
                                                const isDesafioOrGame = ex?.origen_success === 1 || ex?.origen_success === 2 ||
                                                    ex?.origen_success === "1" || ex?.origen_success === "2";
                                                const achievedTrophy = isDesafioOrGame ? ex.trofeus?.find((t: any) => t.is_me === 1) : null;

                                                return (
                                                    <Tooltip key={idx} title={`${ex.prac} (Intents: ${ex.intents})${achievedTrophy ? ` - 🏆 ${achievedTrophy.nom}` : ''}`}>
                                                        <div
                                                            onClick={() => {
                                                                // Obrim el modal d'edició del professor (Historial i Re-Enviament)
                                                                setRevisioElement({
                                                                    ...ex,
                                                                    id: ex.id,
                                                                    id_usuari: student.id_usuari + "",
                                                                    id_practica: id_activitat + "",
                                                                    prac: ex.prac
                                                                });
                                                                setRevisioVisible(true);
                                                            }}
                                                            style={{
                                                                width: achievedTrophy ? 28 : 24,
                                                                height: 16,
                                                                borderRadius: 2,
                                                                backgroundColor: color,
                                                                border: achievedTrophy ? `2px solid ${achievedTrophy.color}` : '1px solid #e0e0e0',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '8px',
                                                                fontWeight: 'bold',
                                                                color: (ex.progres > 0 || ex.intents > 0) ? '#fff' : '#595959',
                                                                cursor: 'pointer',
                                                                boxShadow: achievedTrophy ? `0 0 4px ${achievedTrophy.color}` : 'none'
                                                            }}
                                                        >
                                                            {idx + 1} {achievedTrophy && <span style={{ marginLeft: 2, fontSize: '6px' }}>👑</span>}
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }) : (
                                                <Text type="secondary" style={{ fontSize: 10, width: '100%', textAlign: 'center' }}>Sense exercicis</Text>
                                            )}
                                        </div>

                                        {/* Subtle ID Tag in bottom right */}
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                            <Tag style={{
                                                margin: 0,
                                                fontSize: 9,
                                                lineHeight: '14px',
                                                padding: '0 4px',
                                                borderRadius: 3,
                                                color: '#bfbfbf',
                                                borderColor: '#f0f0f0',
                                                backgroundColor: '#fafafa'
                                            }}>
                                                #{student.id_usuari || student.numericId || student.id}
                                            </Tag>
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </Col>
            </Row>

            {/* Modal d'edició del professor: historial, re-enviament, eliminar entregues, tests i enunciat */}
            {revisioVisible && revisioElement && (
                <RevisioModal
                    element={revisioElement}
                    visible={revisioVisible}
                    onClose={() => {
                        setRevisioVisible(false);
                        setTimeout(() => setRevisioElement(null), 300);
                        checkDades(true);
                    }}
                />
            )}

            {/* Modal de recompenses de l'alumne */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <GiftOutlined style={{ color: '#faad14', fontSize: 20 }} />
                        <span>Recompenses de {selectedStudentRewards?.student?.nom ? `${selectedStudentRewards.student.nom} ${selectedStudentRewards.student.cognoms || ''}` : selectedStudentRewards?.student?.usuari}</span>
                    </div>
                }
                open={rewardsModalVisible}
                onCancel={() => {
                    setRewardsModalVisible(false);
                    setSelectedStudentRewards(null);
                }}
                footer={[
                    <Button key="close" type="primary" onClick={() => {
                        setRewardsModalVisible(false);
                        setSelectedStudentRewards(null);
                    }}>
                        Tancar
                    </Button>
                ]}
                width={650}
            >
                {(!selectedStudentRewards?.rewards || selectedStudentRewards.rewards.length === 0) ? (
                    <div style={{ textAlign: 'center', padding: '32px 0', color: '#888' }}>
                        <GiftOutlined style={{ fontSize: 36, color: '#d9d9d9', marginBottom: 12, display: 'block' }} />
                        <Text type="secondary">Aquesta activitat no té recompenses configurades o assignades per a aquest alumne.</Text>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
                        {selectedStudentRewards.rewards.map((rew: any, idx: number) => {
                            const isClaimed = Number(rew.reclamada) === 1 || Number(rew.obtained) === 1;
                            let items: any[] = [];

                            if (rew.id_javamon) {
                                const urlBase = process.env.REACT_APP_API_URL || 'http://localhost';
                                const imgUrl = `${urlBase}:8061/jutge/game/image/javamon/${rew.id_javamon}`;
                                const isEscapado = rew.estado_javamon === 'ESCAPADO';
                                items.push(
                                    <div key="javamon" style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f5f5f5', padding: '4px 10px', borderRadius: 8 }}>
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            <img
                                                src={imgUrl}
                                                alt="javamon"
                                                style={{
                                                    width: 32,
                                                    height: 32,
                                                    objectFit: 'contain',
                                                    filter: isEscapado ? 'grayscale(100%) opacity(50%)' : 'none'
                                                }}
                                            />
                                            {isEscapado && (
                                                <span style={{ position: 'absolute', top: -5, right: -5, color: 'red', fontSize: '14px', fontWeight: 'bold' }}>✕</span>
                                            )}
                                        </div>
                                        <Text style={{ fontSize: 12 }}>
                                            {isEscapado ? 'Javamon (Escapat)' : 'Javamon (Capturat)'}
                                        </Text>
                                    </div>
                                );
                            }

                            if (rew.rewards_json) {
                                try {
                                    const parsed = typeof rew.rewards_json === 'string' ? JSON.parse(rew.rewards_json) : rew.rewards_json;
                                    if (Array.isArray(parsed)) {
                                        parsed.forEach((r: any, rIdx: number) => {
                                            if (r.tipo === 'PUNTUACION') {
                                                items.push(
                                                    <Tag key={`pts_${rIdx}`} color={isClaimed ? "gold" : "default"} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, opacity: isClaimed ? 1 : 0.85 }}>
                                                        +{r.valor} Punts
                                                    </Tag>
                                                );
                                            } else if (r.tipo !== 'JAVAMON_RANDOM' && r.tipo !== 'JAVAMON') {
                                                const urlBase = process.env.REACT_APP_API_URL || 'http://localhost';
                                                let typeSegment = (r.tipo || '').toLowerCase();
                                                if (typeSegment === "escudo") typeSegment = "escut";
                                                if (typeSegment === "arco") typeSegment = "arc";
                                                if (typeSegment === "shop_item") typeSegment = "shop";
                                                const imgUrl = `${urlBase}:8061/jutge/game/image/${typeSegment}/${r.id_item}`;
                                                items.push(
                                                    <div key={`item_${rIdx}`} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 6,
                                                        background: isClaimed ? '#f9f9f9' : '#fafafa',
                                                        border: isClaimed ? '1px solid #eee' : '1px dashed #d9d9d9',
                                                        padding: '3px 8px',
                                                        borderRadius: 6,
                                                        opacity: isClaimed ? 1 : 0.85
                                                    }}>
                                                        <img src={imgUrl} alt={r.tipo} style={{ width: 22, height: 22, objectFit: 'contain' }} />
                                                        <Text style={{ fontSize: 11 }}>{r.tipo}</Text>
                                                    </div>
                                                );
                                            } else if (!isClaimed && (r.tipo === 'JAVAMON_RANDOM' || r.tipo === 'JAVAMON')) {
                                                items.push(
                                                    <Tag key={`jm_${rIdx}`} color="purple" style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, opacity: 0.85 }}>
                                                        Javamon pendent
                                                    </Tag>
                                                );
                                            }
                                        });
                                    }
                                } catch (e) { /* ignore json parse */ }
                            }

                            return (
                                <Card
                                    key={idx}
                                    size="small"
                                    style={{
                                        borderRadius: 8,
                                        borderColor: isClaimed ? '#b7eb8f' : '#f0f0f0',
                                        backgroundColor: isClaimed ? '#fcffe6' : '#fafafa',
                                        borderStyle: isClaimed ? 'solid' : 'dashed'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                        <Text strong style={{ fontSize: 13, color: isClaimed ? '#52c41a' : '#8c8c8c' }}>
                                            {rew.nom_problema || `Exercici #${rew.id_problema}`}
                                        </Text>
                                        {isClaimed ? (
                                            <Tag color="success">Reclamada</Tag>
                                        ) : (
                                            <Tag color="warning">Pendent / No reclamada</Tag>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginTop: 4 }}>
                                        {items.length > 0 ? items : <Text type="secondary" style={{ fontSize: 11 }}>Sense ítems addicionals</Text>}
                                    </div>
                                </Card>
                            );
                        })}
                    </div>
                )}
            </Modal>

            {/* Modal de confirmació per arrencar tots els dockers d'alumnes */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#52c41a' }}>
                        <PoweroffOutlined style={{ fontSize: 20 }} />
                        <span>Arrencar Dockers dels Alumnes</span>
                    </div>
                }
                open={provisionModalVisible}
                onCancel={() => {
                    if (!provisioningLoading) {
                        setProvisionModalVisible(false);
                    }
                }}
                confirmLoading={provisioningLoading}
                onOk={handleProvisionAllDockers}
                okText={provisioningLoading ? "Arrencant..." : "Confirmar i Arrencar Tots"}
                okButtonProps={{ style: { backgroundColor: '#52c41a', borderColor: '#52c41a' } }}
                cancelButtonProps={{ disabled: provisioningLoading }}
            >
                <div style={{ padding: '8px 0' }}>
                    <p>
                        Estàs a punt d'iniciar el contenidor Docker (IDE Web) per a tots els <strong>{dades?.length || 0} alumnes</strong> d'aquesta activitat / aula.
                    </p>
                    <p style={{ color: '#8c8c8c', fontSize: 13, marginBottom: provisionProgress ? 16 : 0 }}>
                        Aquesta acció inicialitzarà els serveis Theia individuals en segon pla perquè quan els alumnes entrin no hagin d'esperar el temps d'arrencada.
                    </p>
                    {provisionProgress && (
                        <div style={{ marginTop: 12 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <Text type="secondary">Iniciant contenidors...</Text>
                                <Text strong>{provisionProgress.current} / {provisionProgress.total}</Text>
                            </div>
                            <Progress
                                percent={Math.round((provisionProgress.current / provisionProgress.total) * 100)}
                                status="active"
                                strokeColor="#52c41a"
                            />
                        </div>
                    )}
                </div>
            </Modal>

            {/* Modal d'Historial de Telemetria (Monitoreo IDE per Alumne) */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <HistoryOutlined style={{ color: '#1890ff', fontSize: 20 }} />
                        <span>
                            Historial IDE: {telemetryStudent?.nom ? `${telemetryStudent.nom} ${telemetryStudent.cognoms || ''}` : telemetryStudent?.usuari}
                        </span>
                    </div>
                }
                open={telemetryModalVisible}
                onCancel={() => {
                    setTelemetryModalVisible(false);
                    setTelemetryStudent(null);
                }}
                footer={[
                    <Button key="close" type="primary" onClick={() => {
                        setTelemetryModalVisible(false);
                        setTelemetryStudent(null);
                    }}>
                        Tancar
                    </Button>
                ]}
                width={780}
            >
                {telemetryStudent && (
                    <>
                        {/* Selector de dia y estadísticas del día */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8, background: '#fafafa', padding: '10px 14px', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                            <Space size="small">
                                <Button
                                    icon={<LeftOutlined />}
                                    onClick={() => setTelemetryDate(d => d.subtract(1, 'day'))}
                                    title="Dia anterior"
                                />
                                <DatePicker
                                    value={telemetryDate}
                                    onChange={d => d && setTelemetryDate(d)}
                                    allowClear={false}
                                    format="DD/MM/YYYY"
                                    style={{ width: 130 }}
                                />
                                <Button
                                    icon={<RightOutlined />}
                                    onClick={() => setTelemetryDate(d => d.add(1, 'day'))}
                                    disabled={telemetryDate.isSame(dayjs(), 'day')}
                                    title="Dia següent"
                                />
                                {!isTodaySelected && (
                                    <Button
                                        type="dashed"
                                        size="small"
                                        onClick={() => setTelemetryDate(dayjs())}
                                    >
                                        Avui
                                    </Button>
                                )}
                            </Space>

                            {/* Resumen del estado actual del alumno */}
                            <Space size="small">
                                {(() => {
                                    const tel = getStudentTelemetryStatus(telemetryStudent);
                                    if (tel.status === 'activo') return <Tag color="green" icon={<ThunderboltOutlined />}>ACTIU (Escribint codi)</Tag>;
                                    if (tel.status === 'conectado') return <Tag color="blue" icon={<DesktopOutlined />}>CONNECTAT (IDE Obert)</Tag>;
                                    return <Tag color="default">DESCONNECTAT</Tag>;
                                })()}
                            </Space>
                        </div>

                        {/* Tabs entre Línia temporal i Historial de Copiar/Pegar */}
                        <Tabs
                            activeKey={activeTelemetryTabKey}
                            onChange={(k: any) => setActiveTelemetryTabKey(k)}
                            items={[
                                {
                                    key: 'timeline',
                                    label: <span><ClockCircleOutlined /> Línia de Temps</span>,
                                    children: (
                                        <>
                                            {/* Filtre per fitxer treballat */}
                                            {Object.keys(availableTelemetryFiles).length > 0 && (
                                                <div style={{ marginBottom: 16, padding: '8px 12px', background: '#ffffff', borderRadius: 6, border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                                                    <Space size="small">
                                                        <Text strong style={{ fontSize: 13 }}><FileOutlined /> Fitxer:</Text>
                                                        <Select
                                                            style={{ width: 300 }}
                                                            allowClear
                                                            placeholder="Tots els fitxers"
                                                            value={selectedFileFilter}
                                                            onChange={val => setSelectedFileFilter(val || null)}
                                                        >
                                                            {Object.entries(availableTelemetryFiles).map(([fname, info]) => (
                                                                <Select.Option key={fname} value={fname}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                        <span>{fname}</span>
                                                                        <Space size={4}>
                                                                            {info.edits > 0 && <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>{info.edits} edits</Tag>}
                                                                            <Tag style={{ fontSize: 10, margin: 0 }}>{info.count} regs</Tag>
                                                                        </Space>
                                                                    </div>
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Space>
                                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                                        {Object.keys(availableTelemetryFiles).length} {Object.keys(availableTelemetryFiles).length === 1 ? 'fitxer detectat' : 'fitxers detectats'}
                                                    </Text>
                                                </div>
                                            )}

                                            {/* Línia temporal d'esdeveniments */}
                                            {telemetryLoading ? (
                                                <div style={{ textAlign: 'center', padding: 32 }}>Carregant historial de telemetria...</div>
                                            ) : groupedTelemetryItems.length === 0 ? (
                                                <Empty description={`Sense activitat registrada per al ${telemetryDate.format('DD/MM/YYYY')}`} style={{ padding: '24px 0' }} />
                                            ) : (
                                                <Timeline
                                                    style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}
                                                    items={groupedTelemetryItems.map((item: any, idx: number) => {
                                                        const ev = item.representativeEvent;
                                                        const st = item.eventStatus;

                                                        const statusColor = st === 'activo' ? 'green' : st === 'conectado' ? 'blue' : 'gray';
                                                        const statusDot = st === 'activo'
                                                            ? <ThunderboltOutlined style={{ color: '#52c41a' }} />
                                                            : st === 'conectado'
                                                                ? <DesktopOutlined style={{ color: '#1890ff' }} />
                                                                : <MinusCircleTwoTone twoToneColor="#bbb" />;
                                                        const statusTag = st === 'activo'
                                                            ? <Tag color="green" icon={<ThunderboltOutlined />}>actiu</Tag>
                                                            : st === 'conectado'
                                                                ? <Tag color="blue" icon={<DesktopOutlined />}>connectat</Tag>
                                                                : <Tag>desconnectat</Tag>;

                                                        if (item.isGroup || (item.files && item.files.length > 1)) {
                                                            const groupLabel = st === 'activo'
                                                                ? 'actiu sense edicions' : st === 'conectado'
                                                                    ? 'connectat sense canvis' : 'desconnectat';
                                                            return {
                                                                key: `group-${idx}-${item.startTs}`,
                                                                color: statusColor,
                                                                dot: statusDot,
                                                                children: (
                                                                    <div style={{ padding: '4px 0' }}>
                                                                        <Space wrap>
                                                                            <Text strong>
                                                                                {formatDateTime(item.startTs)} — {formatDateTime(item.endTs)}
                                                                            </Text>
                                                                            <Tag color={statusColor}>
                                                                                {item.count} intervals {groupLabel}
                                                                            </Tag>
                                                                            {item.totalActiveSeconds > 0 && (
                                                                                <Tag>{formatDuration(item.totalActiveSeconds)} acumulats</Tag>
                                                                            )}
                                                                        </Space>
                                                                        {item.files && item.files.length > 0 && (
                                                                            <div style={{ fontSize: 12, color: '#888', marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                                <FileOutlined style={{ marginRight: 4 }} />
                                                                                {item.files.map((f: string) => (
                                                                                    <Tag key={f} style={{ fontSize: 11, margin: 0 }}>{f}</Tag>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )
                                                            };
                                                        }

                                                        return {
                                                            key: `ev-${item.representativeEvent.id || idx}`,
                                                            color: statusColor,
                                                            dot: statusDot,
                                                            children: (
                                                                <div>
                                                                    <div>
                                                                        <Text strong>{formatDateTime(ev.event_ts)}</Text>{' '}
                                                                        {statusTag}
                                                                        {ev.edits > 0 && <Tag color="purple">{ev.edits} edicions</Tag>}
                                                                        {(ev.runs || 0) > 0 && <Tag color="cyan" icon={<PlayCircleOutlined />}>{ev.runs} run</Tag>}
                                                                        {(ev.debugs || 0) > 0 && <Tag color="magenta" icon={<BugOutlined />}>{ev.debugs} debug</Tag>}
                                                                        {ev.active_seconds > 0 && <Tag>{formatDuration(ev.active_seconds)}</Tag>}
                                                                    </div>
                                                                    <div style={{ fontSize: 12, color: '#666', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                        <div>
                                                                            <FileOutlined /> {ev.file || '—'}
                                                                            {ev.language ? <Tag color="blue" style={{ marginLeft: 8 }}>{ev.language}</Tag> : null}
                                                                            {ev.project ? <Tag style={{ marginLeft: 4 }}>{ev.project}</Tag> : null}
                                                                        </div>
                                                                        {ev.code_snippet && item.hasCodeChange && (
                                                                            <Space>
                                                                                <Button
                                                                                    size="small"
                                                                                    type="primary"
                                                                                    ghost
                                                                                    icon={<CodeOutlined />}
                                                                                    onClick={() => {
                                                                                        setPreviousCodeSnippet(item.prevSnippet);
                                                                                        setCodeViewMode(item.prevSnippet ? 'diff' : 'current');
                                                                                        setSelectedCodeEvent(ev);
                                                                                        setCodeModalVisible(true);
                                                                                    }}
                                                                                >
                                                                                    Veure diff / codi
                                                                                </Button>
                                                                            </Space>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )
                                                        };
                                                    })}
                                                />
                                            )}
                                        </>
                                    )
                                },
                                {
                                    key: 'clipboard',
                                    label: (
                                        <span>
                                            <CopyOutlined /> Copiar / Pegar
                                            {telemetryClipboardEvents.length > 0 && (
                                                <Tag color="red" style={{ marginLeft: 6, fontSize: 11, borderRadius: 8, padding: '0 5px' }}>
                                                    {telemetryClipboardEvents.length}
                                                </Tag>
                                            )}
                                        </span>
                                    ),
                                    children: (
                                        <div style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}>
                                            {telemetryClipboardEvents.length === 0 ? (
                                                <Empty description="No s'han detectat operacions de copiar ni pegar per a aquest alumne" />
                                            ) : (
                                                <Table
                                                    size="small"
                                                    dataSource={telemetryClipboardEvents}
                                                    rowKey="id"
                                                    pagination={{ pageSize: 8 }}
                                                    columns={[
                                                        {
                                                            title: 'Acció',
                                                            dataIndex: 'action_type',
                                                            key: 'action_type',
                                                            width: 90,
                                                            render: (action: string) => {
                                                                const color = action === 'PASTE' ? 'orange' : action === 'COPY' ? 'blue' : action === 'CUT' ? 'volcano' : 'green';
                                                                return <Tag color={color} style={{ fontWeight: 'bold' }}>{action}</Tag>;
                                                            }
                                                        },
                                                        {
                                                            title: 'Origen',
                                                            dataIndex: 'source_element',
                                                            key: 'source_element',
                                                            width: 120,
                                                            render: (src: string) => <Tag color="geekblue">{src || 'EXAM_FRAME'}</Tag>
                                                        },
                                                        {
                                                            title: 'Data i hora',
                                                            dataIndex: 'event_ts',
                                                            key: 'event_ts',
                                                            width: 150,
                                                            render: (ts: string) => formatDateTime(ts)
                                                        },
                                                        {
                                                            title: 'Contingut Copiat/Pegat',
                                                            dataIndex: 'content_text',
                                                            key: 'content_text',
                                                            render: (txt: string) => (
                                                                <div style={{
                                                                    maxHeight: 70,
                                                                    maxWidth: 320,
                                                                    overflowY: 'auto',
                                                                    background: '#f5f5f5',
                                                                    padding: '4px 6px',
                                                                    borderRadius: 4,
                                                                    fontFamily: 'monospace',
                                                                    fontSize: 11,
                                                                    whiteSpace: 'pre-wrap',
                                                                    wordBreak: 'break-all'
                                                                }}>
                                                                    {txt || '(buit)'}
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    )
                                },
                                {
                                    key: 'locks',
                                    label: (
                                        <span>
                                            <LockOutlined /> Bloquejos
                                            {telemetryLockEvents.filter((e: any) => e.action_type === 'LOCK').length > 0 && (
                                                <Tag color="red" style={{ marginLeft: 6, fontSize: 11, borderRadius: 8, padding: '0 5px' }}>
                                                    {telemetryLockEvents.filter((e: any) => e.action_type === 'LOCK').length}
                                                </Tag>
                                            )}
                                        </span>
                                    ),
                                    children: (
                                        <div style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}>
                                            {telemetryLockEvents.length === 0 ? (
                                                <Empty description="No s'han registrat bloquejos per a aquest alumne" />
                                            ) : (
                                                <Table
                                                    size="small"
                                                    dataSource={telemetryLockEvents}
                                                    rowKey="id"
                                                    pagination={{ pageSize: 8 }}
                                                    columns={[
                                                        {
                                                            title: 'Acció',
                                                            dataIndex: 'action_type',
                                                            key: 'action_type',
                                                            width: 110,
                                                            render: (action: string) => action === 'UNLOCK'
                                                                ? <Tag color="green" icon={<UnlockOutlined />} style={{ fontWeight: 'bold' }}>Desbloqueig</Tag>
                                                                : <Tag color="red" icon={<LockOutlined />} style={{ fontWeight: 'bold' }}>Bloqueig</Tag>
                                                        },
                                                        {
                                                            title: 'Motiu',
                                                            dataIndex: 'reason',
                                                            key: 'reason',
                                                            width: 140,
                                                            render: (reason: string) => reason
                                                                ? <Tag color={reason === 'FOCUS_LOST' ? 'volcano' : 'geekblue'}>{reason}</Tag>
                                                                : '-'
                                                        },
                                                        {
                                                            title: 'Data i hora',
                                                            dataIndex: 'event_ts',
                                                            key: 'event_ts',
                                                            width: 150,
                                                            render: (ts: string) => formatDateTime(ts)
                                                        },
                                                        {
                                                            title: 'Detall',
                                                            dataIndex: 'detail',
                                                            key: 'detail',
                                                            render: (txt: string, row: any) => (
                                                                <div>
                                                                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{txt || '-'}</div>
                                                                    {row.actor_nom && (
                                                                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                                                                            Per: {row.actor_nom}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    )
                                }
                            ]}
                        />

                    </>
                )}
            </Modal>

            {/* Modal Visor de Codi amb vista Diff o Completa */}
            <Modal
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 32 }}>
                        <Space wrap>
                            <CodeOutlined />
                            <span>
                                <strong>{selectedCodeEvent?.file || 'fitxer'}</strong> — {formatDateTime(selectedCodeEvent?.event_ts)}
                            </span>
                            {selectedCodeEvent?.language && <Tag color="blue">{selectedCodeEvent.language}</Tag>}
                            {selectedCodeEvent?.edits ? <Tag color="purple">{selectedCodeEvent.edits} edicions</Tag> : null}
                        </Space>
                        {previousCodeSnippet && (
                            <Radio.Group
                                size="small"
                                value={codeViewMode}
                                onChange={e => setCodeViewMode(e.target.value)}
                                buttonStyle="solid"
                            >
                                <Radio.Button value="diff">Veure Canvis (Diff)</Radio.Button>
                                <Radio.Button value="current">Codi Complet</Radio.Button>
                            </Radio.Group>
                        )}
                    </div>
                }
                open={codeModalVisible}
                onCancel={() => setCodeModalVisible(false)}
                footer={<Button onClick={() => setCodeModalVisible(false)}>Tancar</Button>}
                width={920}
                bodyStyle={{ padding: 0 }}
            >
                <div style={{ height: 480, borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0' }}>
                    {codeViewMode === 'diff' && previousCodeSnippet ? (
                        <DiffEditor
                            height="100%"
                            language={(selectedCodeEvent?.language || 'java').toLowerCase()}
                            original={previousCodeSnippet}
                            modified={selectedCodeEvent?.code_snippet || ''}
                            theme="vs-dark"
                            options={{
                                readOnly: true,
                                renderSideBySide: true,
                                minimap: { enabled: false },
                                fontSize: 13,
                                lineNumbers: 'on',
                                scrollBeyondLastLine: false,
                                automaticLayout: true
                            }}
                        />
                    ) : (
                        <Editor
                            height="100%"
                            language={(selectedCodeEvent?.language || 'java').toLowerCase()}
                            value={selectedCodeEvent?.code_snippet || '// No hi ha contingut disponible'}
                            theme="vs-dark"
                            options={{
                                readOnly: true,
                                minimap: { enabled: false },
                                fontSize: 13,
                                lineNumbers: 'on',
                                scrollBeyondLastLine: false,
                                automaticLayout: true
                            }}
                        />
                    )}
                </div>
            </Modal>

            {fileBrowserUser && (
                <IdeFileBrowserModal
                    visible={fileBrowserVisible}
                    onClose={() => setFileBrowserVisible(false)}
                    userId={fileBrowserUser.id}
                    studentName={fileBrowserUser.name}
                />
            )}
        </div>
    );
};


export default ActivitatsIdEstadistiques;
